import { toast } from 'react-toastify';

import { customerDataMicroserviceRequest } from './api/customer-data';

export async function loadSicCodeParentCategories(setCategories, setLoadingCategories) {
    try {
        const {
            data: sicCodeCategories,
        } = await customerDataMicroserviceRequest('get', process.env.SPONSOR_MANAGEMENT_API_URL, '/sponsors/sic-code-categories');

        const parentCategoryDataObject = {};
        sicCodeCategories.forEach((category) => {
            parentCategoryDataObject[category.id] = {
                name: category.name,
                sicCodes: category.sicCodes,
            };
        });

        setCategories(parentCategoryDataObject);
    } catch (error) {
        toast.error(`There was an error loading search categories.
            Please try again in a few minutes.`);
    } finally {
        setLoadingCategories(false);
    }
}

export async function loadKeywordSicCodes(keyword, setSicCodes) {
    try {
        const encodedKeyword = encodeURIComponent(keyword);

        const {
            data: keywordSicCodes,
        } = await customerDataMicroserviceRequest('get', process.env.SPONSOR_MANAGEMENT_API_URL, `/sponsors/sic-codes/${encodedKeyword}`);

        setSicCodes(keywordSicCodes);
    } catch (error) {
        setSicCodes([]);
    }
}
